import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChartViewDTO } from '../../model/chart_view/chart-view-dto';
import { QuantiteDossierPrecontentieuxDTO } from '../../model/QuantiteDossierPrecontentieuxDTO';
import { PageDossierDTO } from 'src/app/suivi-portefeuille/core/model/page-DossierDTO';

@Injectable({
  providedIn: "root"
})
export class DashboardProvisionServiceService {
  constructor(private _restClientService: RestClientService) {}

  nombreDossierProvions() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-provision/nombre-dossier-contentieux-provision-filtrer-Sur-periode"
    );
  }

  quantiteDossierParMarcheSurLes6DerniersMois() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-provision/quantite-dossier-provision-by-marche-surLes6DerniersMois"
    );
  }

  quantiteDossierProvision() {
    return this._restClientService.load<QuantiteDossierPrecontentieuxDTO[]>(
      "dashboard-provision/historique-provision"
    );
  }

  /*
  quantiteDossierProvision() {
    return this._restClientService.load<QuantiteDossierPrecontentieuxDTO[]>(
      "dashboard-provision/dossier-pageable-provision"
    );
  }*/



  findAllPagingDossierProvision(filter, page, size, sortColumn, descending) {
    return this._restClientService.load<PageDossierDTO>(
      "dashboard-provision/dossier-pageable-provision" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColumn=" +
        sortColumn +
        "&descending=" +
        descending
    );
  }
}
